import ProductComponent from "../../components/admin/products/ProductComponent";
import ProductListComponent from "../../components/admin/products/ProductListComponent";
import ProductShowComponent from "../../components/admin/products/ProductShowComponent";
import AiImportListComponent from "../../components/admin/products/ai-import/AiImportListComponent";
import AiImportShowComponent from "../../components/admin/products/ai-import/AiImportShowComponent";

export default [
    {
        path: '/admin/productos',
        component: ProductComponent,
        name: 'admin.products',
        redirect: { name: 'admin.products.list' },
        meta: {
            isFrontend: false,
            auth: true,
            permissionUrl: 'products',
            breadcrumb: 'products'
        },
        children: [
            {
                path: '',
                component: ProductListComponent,
                name: 'admin.products.list',
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: 'products',
                    breadcrumb: ''
                },
            },
            {
                path: "ver/:id",
                component: ProductShowComponent,
                name: "admin.product.show",
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: "products",
                    breadcrumb: "view",
                },
            },
            {
                path: "importacion-ia",
                component: AiImportListComponent,
                name: "admin.products.aiImport",
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: "products",
                    breadcrumb: "ai_imports",
                },
            },
            {
                path: "importacion-ia/ver/:id",
                component: AiImportShowComponent,
                name: "admin.products.aiImport.show",
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: "products",
                    breadcrumb: "view",
                },
            }
        ]
    }
]
